export default class MagicMode {
	constructor(controls) {
		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
		this.controls = controls;
	}

	async addBlock(blockNum = lutify.blocks.length, data = false) {
		this.controls.forEach(controlData => (controlData.control = controlData.name));
		UI.createAdjustmentBlockTemplate("magic-mode", blockNum, data);
		let $element = $(UI.getAdjustmentBlock(blockNum));

		lutify.magicMode.isApplied = true;

		UI.appendBlockLoadingSpinner($element);
		lutPreviewer.showPlaceholderPreviews();
		await this.loadControlLuts(this.controls[0], false);
		UI.removeBlockLoadingSpinner($element);

		this.addControls($element);
		if (data) this.removeNav(); // coming from loading a preset/candidate
		this.createNavSteps();
		this.createNavLabel();

		$element.find(".lut-selector__items-container").hide();

		$element.on("click", e => {
			e.stopImmediatePropagation();

			if (!vm.$store.getters['User/isGuest']) {
				$("#magic-mode-nav-label").removeClass("hide");
				$("#magic-mode-nav-container").removeClass("hide");
			}

			if (lutify.magicMode.activeStep) {
				lutify.selectedPreviewCategory = this.controls[lutify.magicMode.activeStep].category;

				let controlName = this.controls[lutify.magicMode.activeStep].name;
				let controlCategory = this.controls[lutify.magicMode.activeStep].category;

				if (luts.loaded[controlName].controls[controlCategory].status == "loaded") {
					this.showPreviews(lutify.magicMode.activeStep);
				} else {
					UI.togglePreviewsContainer();
					lutPreviewer.showPlaceholderPreviews();
				}
			}
		});

		$element.find(".btn-remove-block").on("click", _ => this.removeMagicMode());
		$element
			.find(".btn-reset-block")
			.off("click")
			.on("click", e => this.resetBlock($element, e));
		$element.find(".btn-reset-selection").on("click", e => this.removeSelection(e));
		$element.find(".opacity_slider").on("input", _ => this.opacitySliderHandler($element));
		$element.find(".opacity-input").on("change", _ => this.opacityInputHandler($element));

		$element.find(".lut-selector__label-container").on("click", e => {
			// e.stopPropagation();
			this.toggleControlSelector($(e.currentTarget));
		});

		blocks.add({
			name: "magicMode",
			// control: data.control,
			passes: this.addPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			selectedPreview: this.controls.map(_ => null),
			selectedPreviewName: this.controls.map(_ => null),
			opacity: this.controls.map(_ => 100),
		});

		$element.find(".expand_options").trigger("click", [false]);
		$element
			.find(".magic-mode-controls-container i")
			.eq(0)
			.trigger("click");
		UI.scrollToBlock(blockNum);
		UI.attachTemporaryLUTSelectionHandler();

		if (data && data.waitToLoad) await this.loadAllControlLuts("waitToLoad");
		// coming from loading a preset/candidate
		else this.loadAllControlLuts();
	}

	addControls($element) {
		this.controls.forEach((controlData, i) => {
			let item = document.createElement("i");
			item.setAttribute("data-name", controlData.name);
			item.setAttribute("data-category", controlData.category);
			item.setAttribute("data-step", i);
			item.setAttribute("data-tippy-content", controlData.label);
			item.setAttribute("class", "material-icons");
			if (i == 0) item.setAttribute("class", "material-icons --selected");
			item.innerHTML = controlData.icon;
			item.addEventListener("click", e => {
				e.stopPropagation();
				this.controlClickEvent(e.currentTarget);
			});
			$element.find(".magic-mode-controls-container").append(item);
		});
	}

	createNavSteps() {
		if ($("#magic-mode-nav-container").length > 0) return;

		let container = document.createElement("div");
		container.setAttribute("id", "magic-mode-nav-container");
		if (vm.$store.getters['User/isGuest']) container.setAttribute("class", "hide");
		// let arrowLeft = '<i id="magic-mode-prev-btn" data-action="prev" class="material-icons nav-btn">keyboard_arrow_left</i>';
		// let arrowRight = '<i id="magic-mode-next-btn" data-action="next" class="material-icons nav-btn">keyboard_arrow_right</i>';

		this.controls.forEach((controlData, i) => {
			let item = document.createElement("i");
			item.setAttribute("data-name", controlData.name);
			item.setAttribute("data-category", controlData.category);
			item.setAttribute("data-step", i);
			item.setAttribute("data-tippy-content", controlData.label);
			item.setAttribute("class", "material-icons nav-step");
			item.innerHTML = controlData.icon;
			if (i == 0) item.setAttribute("class", "material-icons nav-step --selected");
			container.appendChild(item);
		});

		$("#wrapper #content").append(container);
		// $('#magic-mode-nav-container').prepend(arrowLeft);
		// $('#magic-mode-nav-container').append(arrowRight);

		$("#magic-mode-nav-container .nav-step").on("click", (e, triggerChange) => {
			e.stopPropagation();
			this.navClickEvent(e.currentTarget, triggerChange);
		});
		// $('#magic-mode-prev-btn').on('click', e => this.navArrowHandler(e.currentTarget));
		// $('#magic-mode-next-btn').on('click', e => this.navArrowHandler(e.currentTarget));
	}

	createNavLabel() {
		let label = document.createElement("span");
		label.setAttribute("id", "magic-mode-nav-label");
		if (vm.$store.getters['User/isGuest']) label.setAttribute("class", "hide");
		$("#wrapper #content").prepend(label);
	}

	updateNavLabel() {
		$("#magic-mode-nav-label").html(this.controls[lutify.magicMode.activeStep].label);
	}

	navArrowHandler(action = "next") {
		let gotoStep;
		action == "next" ? (gotoStep = parseInt(lutify.magicMode.activeStep) + 1) : (gotoStep = parseInt(lutify.magicMode.activeStep) - 1);
		$(`#magic-mode-nav-container .nav-step[data-step="${gotoStep}"]`).trigger("click");
	}

	toggleControlSelector($el) {
		let itemsContainer = $el.siblings(".lut-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	controlClickEvent(control) {
		lutify.magicMode.activeStep = control.dataset.step;
		$(".magic-mode-controls-container i").removeClass("--selected");
		control.classList.add("--selected");
		$(`#magic-mode-nav-container .nav-step[data-step="${control.dataset.step}"]`).trigger("click", [false]);
		UI.getActiveBlock().find(".opacity_slider").val(lutify.getActiveBlock().opacity[lutify.magicMode.activeStep]);
		UI.getActiveBlock().find(".opacity-input").val(lutify.getActiveBlock().opacity[lutify.magicMode.activeStep]);
		lutify.selectedPreviewCategory = this.controls[lutify.magicMode.activeStep].category;

		// this.toggleNavArrows();
		this.updateLabel();
		this.updateNavLabel();

		if (luts.loaded[control.dataset.name].controls[control.dataset.category].status == "loaded") {
			this.showPreviews(control.dataset.step);
			this.updateLutsDropdownList();
			this.enableLutDropdown();
		} else {
			this.disableLutDropdown();
			lutPreviewer.showPlaceholderPreviews();
			UI.updatePreviewsTab();
		}
	}

	navClickEvent(control, triggerChange = true) {
		vm.$store.dispatch('UI/setShowLutPreviews', true);
		vm.$nextTick(() => {
			if (window.lutify.getActiveBlock()) window.UI.getActiveBlock().click();
		})

		$("#magic-mode-nav-container .nav-step").removeClass("--selected");
		$(control).addClass("--selected");

		if (triggerChange) $(`.magic-mode-controls-container i[data-step="${control.dataset.step}"]`).trigger("click");
	}

	enableLutDropdown() {
		UI.getActiveBlock()
			.find(".lut-selector")
			.removeClass("--disabled");
		UI.getActiveBlock()
			.find(".block-sliders-container")
			.removeClass("--disabled");
	}

	disableLutDropdown() {
		UI.getActiveBlock()
			.find(".lut-selector")
			.addClass("--disabled");
		UI.getActiveBlock()
			.find(".block-sliders-container")
			.addClass("--disabled");
	}

	updateLabel() {
		if (lutify.getActiveBlock().selectedPreview[lutify.magicMode.activeStep] !== null) {
			// let lutName = UI.getPreviewDescription(lutify.getActiveBlock().selectedPreview[lutify.magicMode.activeStep]);
			let lutName = lutify.getActiveBlock().selectedPreviewName[lutify.magicMode.activeStep];
			UI.getActiveBlock()
				.find(".selected-lut-name")
				.html("Look: " + lutName);
		} else {
			UI.getActiveBlock()
				.find(".selected-lut-name")
				.html("Select...");
		}
	}

	updateLutsDropdownList() {
		let selectedControl = this.controls[lutify.magicMode.activeStep];
		let selectedLuts = luts[selectedControl.control][selectedControl.category];
		let lutsList = UI.createLutDropdownList(selectedLuts);
		UI.getActiveBlock()
			.find(".lut-selector__items-container")
			.html("");
		UI.getActiveBlock()
			.find(".lut-selector__items-container")
			.html(lutsList);
		UI.getActiveBlock()
			.find(".lut-selector__items-container > span")
			.on("click", e => this.lutDropdownSelection(e.currentTarget));
	}

	lutDropdownSelection(selectedLut) {
		let $blockOptions = $(selectedLut).closest(".block_options");
		$blockOptions.find(".lut-selector__items-container").hide();
		this.updateLabel();
		$(`#previews-list-container > .list-item[data-composer-index="${selectedLut.dataset.composerIndex}"]`).trigger("click");
	}

	async loadControlLuts(data, showPreviewsAfterLoad = true) {
		if (typeof luts.loaded[data.control].controls[data.category] == "undefined") {
			luts.loaded[data.control].controls[data.category] = { status: "idle", total: null, fetched: null };
			luts[data.control][data.category] = [];
			// let totalCount = await luts.getLUTcontrolsTotalCount(data.category);
			// luts.loaded[data.control].controls[data.category].total = parseInt(totalCount);
		}

		// When all luts fetched, don't fetch again.
		if (luts.loaded[data.control].controls[data.category].status == "loaded") return;

		if (luts.loaded[data.control].controls[data.category].status == "idle") {
			luts.loaded[data.control].controls[data.category].status = "loading";

			let fetchedLUTs = await luts.fetchLUTcontrols(data);
			await luts.load(fetchedLUTs, luts[data.control][data.category]);

			luts[data.control][data.category].forEach((LUT, key) => {
				LUT.control = data.control;
				LUT.category = data.category;
				LUT.lutId = key + 1;
				// LUT.filename = LUT.name;
				// LUT.categoryType = 'LUT';
				// LUT.blockType = 'LUT';
			});

			luts.loaded[data.control].controls[data.category].fetched += fetchedLUTs.length;

			lutPreviewer.createPreviews(luts[data.control][data.category]);
			luts.loaded[data.control].controls[data.category].status = "loaded";
		}

		// If we add more of the same block while the initial is being in 'loading'
		else if (luts.loaded[data.control].controls[data.category].status == "loading") {
			return await new Promise(resolve => {
				let interval = setInterval(_ => {
					if (luts.loaded[data.control].controls[data.category].status == "loaded") {
						clearInterval(interval);
						resolve();
					}
				}, 500);
			});
		}

		if (lutify.getActiveBlock() && lutify.getActiveBlock().name == "magicMode" && showPreviewsAfterLoad) {
			if (this.controls[lutify.magicMode.activeStep].category == data.category) {
				this.showPreviews(lutify.magicMode.activeStep);
				this.updateLutsDropdownList();
				this.enableLutDropdown();
			}
		}
	}

	async loadAllControlLuts(waitToLoad = false) {
		// when initially loading the block, don't wait for fetch
		if (!waitToLoad) this.controls.forEach(controlData => this.loadControlLuts(controlData));
		// when applying preset/candidate, await all fetching/loading
		else {
			for (const [index, controlData] of this.controls.entries()) {
				await this.loadControlLuts(controlData);
			}
		}
	}

	addPasses() {
		let passes = [];
		for (let i = 0; i < this.controls.length; i++) {
			let renderPass = gpu.createRenderPass();
			gpu.addPassToComposer(renderPass, "toMiddle");
			passes.push(renderPass);
		}
		return passes;
	}

	showPreviews(stepIndex) {
		UI.togglePreviewsContainer();
		lutPreviewer.switchCanvases(this.controls[stepIndex].category);
		UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview[stepIndex]);

		lutPreviewer.cloneMainComposerPasses();
		lutPreviewer.addPass(this.controls[stepIndex].name, this.controls[stepIndex].category, stepIndex);
		lutPreviewer.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = parseInt($element.find(".opacity_slider").val());
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity[lutify.magicMode.activeStep] = opacityValue;
		lutify.getActiveBlock().passes[lutify.magicMode.activeStep].uniforms.opacity.value = calcOpacityValue;
		lutify.getActiveBlock().passes[lutify.magicMode.activeStep].enabled = true;

		lutPreviewer.updateOpacity(calcOpacityValue, lutify.magicMode.activeStep);
		UI.setPreviewerOpacity(lutify.getActiveBlock().opacity[lutify.magicMode.activeStep]);

		gpu.render();
		lutPreviewer.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	resetBlock($element, e) {
		e.stopPropagation();
		$element.find(".opacity-input").val(100);
		$element.find(".opacity-input").trigger("change");

		UI.deselectPreview();
		UI.scrollToSelectedPreview();
		lutify.getActiveBlock().selectedPreview = this.controls.map(_ => null);
		lutify.getActiveBlock().selectedPreviewName = this.controls.map(_ => null);
		// lutify.getActiveBlock().opacity =this.controls.map(_ => 100);

		this.controls.forEach((controlData, i) => {
			let renderPass = gpu.createRenderPass();
			renderPass.uid = lutify.getActiveBlock().passes[i].uid;
			let targetPassIndex = gpu.getPassIndexById(lutify.getActiveBlock().passes[i].uid);
			lutify.getActiveBlock().passes[i] = renderPass;
			gpu.composer.passes[targetPassIndex] = lutify.getActiveBlock().passes[i];
		});

		gpu.render();

		$element.find(".magic-mode-controls-container i").removeClass("--applied");
		$("#magic-mode-nav-container .nav-step").removeClass("--applied");
		$("#magic-mode-nav-container .nav-step").eq(0).trigger("click");
	}

	applyCompare($block, data) {
		data.selectedPreviewName.forEach((selectedData, stepIndex) => {
			if (selectedData !== null) {
				lutify.magicMode.activeStep = stepIndex;

				lutPreviewer.cloneMainComposerPasses();
				lutPreviewer.addPass(this.controls[stepIndex].name, this.controls[stepIndex].category, stepIndex);
				lutPreviewer.render();

				$(
					`#previews-list-container .list-item[data-control="${this.controls[stepIndex].name}"][data-category="${this.controls[stepIndex].category}"][data-name="${selectedData}"]`
				).trigger("click");
				$block.find(".opacity-input").val(parseInt(data.opacity[stepIndex]));
				$block.find(".opacity-input").trigger("change");
			}
		});

		window.lutify.getActiveBlock().collapsedPreviews = data.collapsedPreviews;

		lutify.magicMode.activeStep = 0;
		this.updateLabel();
		setTimeout(_ => UI.hideMagicModeNav(), 100);
		UI.getActiveBlock()
			.find(".magic-mode-controls-container > i.--selected")
			.removeClass("--selected");
	}

	removeSelection(e) {
		e.stopPropagation();
		lutify.getActiveBlock().selectedPreview[lutify.magicMode.activeStep] = null;
		lutify.getActiveBlock().selectedPreviewName[lutify.magicMode.activeStep] = null;
		lutify.getActiveBlock().passes[lutify.magicMode.activeStep].enabled = false;
		gpu.render();
		this.showPreviews(lutify.magicMode.activeStep);
		this.resetAppliedTabs();
		this.updateLabel();
	}

	resetAppliedTabs() {
		$(`.magic-mode-controls-container i[data-step="${lutify.magicMode.activeStep}"]`).removeClass("--applied");
		$(`#magic-mode-nav-container i[data-step="${lutify.magicMode.activeStep}"]`).removeClass("--applied");
	}

	removeMagicMode() {
		lutify.magicMode.isApplied = false;
		lutify.magicMode.activeStep = null;
		this.removeNav();
	}

	removeNav() {
		$("#magic-mode-nav-container").remove();
		$("#magic-mode-nav-label").remove();
	}
}
